/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InventoryReportDTO
 */
export interface InventoryReportDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    containerCode?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    inventoryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    locationCode?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    materialCode?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    operatorCode?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryReportDTO
     */
    qty?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryReportDTO
     */
    warehouseCode?: string;
}

/**
 * Check if a given object implements the InventoryReportDTO interface.
 */
export function instanceOfInventoryReportDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InventoryReportDTOFromJSON(json: any): InventoryReportDTO {
    return InventoryReportDTOFromJSONTyped(json, false);
}

export function InventoryReportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryReportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'containerCode': !exists(json, 'containerCode') ? undefined : json['containerCode'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'inventoryCode': !exists(json, 'inventoryCode') ? undefined : json['inventoryCode'],
        'locationCode': !exists(json, 'locationCode') ? undefined : json['locationCode'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'operatorCode': !exists(json, 'operatorCode') ? undefined : json['operatorCode'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'warehouseCode': !exists(json, 'warehouseCode') ? undefined : json['warehouseCode'],
    };
}

export function InventoryReportDTOToJSON(value?: InventoryReportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'containerCode': value.containerCode,
        'created': value.created,
        'inventoryCode': value.inventoryCode,
        'locationCode': value.locationCode,
        'materialCode': value.materialCode,
        'operatorCode': value.operatorCode,
        'qty': value.qty,
        'user': value.user,
        'warehouseCode': value.warehouseCode,
    };
}

